import React from "react";
import { VictoryLabel, VictoryTooltip } from "victory";
import dashboardColors from "./dashboardColors";


class PieGraphCustomLabel extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <g>
                <VictoryLabel
                    {...this.props}
                    text={({ datum }) => `${datum.companyName}`}
                    style={[
                        { fill: "black",fontFamily: 'Quicksand' },
                    ]}
                />
                <VictoryTooltip
                    {...this.props}
                    x={this.props.width / 2} y={(this.props.height / 2) + 50}
                    orientation="top"
                    pointerLength={0}
                    cornerRadius={50}
                    flyoutWidth={100}
                    flyoutHeight={100}
                    flyoutStyle={{ fill: dashboardColors[0], stroke: dashboardColors[0] }}
                />
            </g>
        );
    }
}

PieGraphCustomLabel.defaultEvents = VictoryTooltip.defaultEvents;

export { PieGraphCustomLabel }